import { LogoEyeballSmall } from "ui-kit/src/icons";
import "./favoriteButton.css";
import clsx from "clsx";
import type { MouseEvent } from "react";

interface FavoriteButtonProps {
	favoriteDisabled?: boolean;
	isFavorite?: boolean | null;
	handleFavorite: (e: MouseEvent<HTMLDivElement>) => void;
}

export default function FavoriteButtonBig({ favoriteDisabled, isFavorite, handleFavorite }: FavoriteButtonProps) {
	return (
		<div
			className={clsx(
				"favButtonBig",
				isFavorite && "is-favNewBig",
				favoriteDisabled && "is-favDisabledBig"
			)}
			onClick={handleFavorite}>
			<LogoEyeballSmall />
		</div>
	);
}
